import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import '~/styles/main.scss';

import { Articles } from './index';

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;
global.Articles = Articles;
// CLR alias: PortableComponent.cshtml renders ArticlesFolder blocks via this component.
global.ArticlesFolder = Articles;
